import { makeStyles } from "@material-ui/core/styles";

export default makeStyles({
    tableHead: {
        backgroundColor: "#E0DFD5",
    }
});
